var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bet-placed-chip",
      class: [
        `bet-placed-chip--${_vm.placement}`,
        { "bet-placed-chip--overlap": _vm.overlap },
      ],
    },
    [
      _c("img", {
        staticClass: "bet-placed-chip__image",
        attrs: { src: _vm.chipImageSrc, alt: "" },
      }),
      _c(
        "span",
        { staticClass: "bet-placed-chip__value", class: _vm.valueClass },
        [_vm._v(_vm._s(_vm.chipLabel))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }